module.exports = __webpack_public_path__ + "img/gricon3.d3504309.png";